import { z } from 'zod';
import { GameStage, MajorCardId, MinorCardId } from '#lib/domain/types.ts';

export type GameState = z.infer<typeof zodGameState>;
export type MajorCardState = z.infer<typeof majorCardZodState>;
export type MinorCardState = z.infer<typeof minorCardZodState>;

const majorCardZodState = z.object({
	hasSavedThisRound: z.boolean(),
	discarded: z.array(z.enum(MajorCardId)),
	hand: z.array(z.enum(MajorCardId)),
	reversed: z.array(z.enum(MajorCardId)),
	saved: z.array(z.enum(MajorCardId))
});

const minorCardZodState = z.object({
	isDisplayingFinaleDeck: z.boolean(),
	discarded: z.array(z.enum(MinorCardId)),
	spread: z.array(z.enum(MinorCardId)),
	flipped: z.array(z.enum(MinorCardId)),
	finaleDeck: z.array(z.enum(MinorCardId))
});

const zodGameState = z.object({
	hasRetrievedFromStorage: z.boolean(),
	gameStage: z.enum(GameStage),
	majorCards: majorCardZodState,
	minorCards: minorCardZodState
});

export const validateGameState = (state: unknown) => {
	return zodGameState.safeParse(state);
};
